import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  types: [],
};

export const useListsStore = create(
  persist(
    (set) => ({
      ...initialState,

      setTypes: (types) => set({ types }),
    }),
    {
      name: 'lists-storage',
      partialize: (state) => ({
        types: state.types
      })
    }
  )
);
